import React from 'react'
import { Card, Typography, Space } from 'antd'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

const { Title, Text } = Typography
// Xero, Quickbooks, MYOB Sage...

export const IntegrationsOverview: React.FC = () => {
  return (
    <div className="space-y-6">
      <Card>
        <Title level={5}>Available Integrations</Title>
        <Text type="secondary" className="block mb-6">
          Connect your favourite tools to streamline your workflow
        </Text>

        <div className="space-y-4">
          <Link to="integrations/xero">
            <Card
              size="small"
              className="cursor-pointer hover:shadow-md transition-shadow"
            >
              <div className="flex items-center justify-between">
                <Space>
                  <img
                    src="/xero_logo.svg"
                    alt="Xero"
                    className="w-12 h-12 rounded"
                  />
                  <div className="pl-4">
                    <Text strong className="block">
                      Xero
                    </Text>
                    <Text type="secondary">Sync purchase orders & suppliers</Text>
                  </div>
                </Space>
                <ArrowRight className="h-5 w-5 text-gray-400" />
              </div>
            </Card>
          </Link>

          {/* Placeholder for future integrations */}
          {/* <Card size="small" className="bg-gray-50 border-dashed">
            <div className="flex items-center justify-between">
              <Space>
                <div className="w-12 h-12 rounded bg-gray-200 flex items-center justify-center">
                  <Text type="secondary">+</Text>
                </div>
                <div>
                  <Text strong className="block">More Coming Soon</Text>
                  <Text type="secondary">Stay tuned for additional integrations</Text>
                </div>
              </Space>
            </div>
          </Card> */}
        </div>
      </Card>
    </div>
  )
}
